module.exports = __webpack_public_path__ + "assets/images/rbyearend-18-desktop.jpg?v=284db593";